import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, ready, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (ready && user) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      nav("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-imi-bg px-6">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
        className="w-full max-w-md border border-imi-border bg-imi-surface p-10">
        <Link to="/" className="flex items-center gap-3 mb-8">
          <img src="/imi-logo.jpg" alt="IMI" className="h-10 w-10 object-cover rounded-sm border border-imi-border" />
          <span className="font-serif text-imi-goldlight text-xl">IMI Admin</span>
        </Link>
        <h1 className="font-serif text-3xl text-imi-text mb-2">Welcome back</h1>
        <p className="text-imi-text/50 text-sm mb-8">Sign in to manage productions, media and messages.</p>
        <form onSubmit={submit} className="space-y-5">
          <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" placeholder="Email"
            className="w-full bg-imi-bg border border-imi-border focus:border-imi-gold outline-none px-4 py-3 text-imi-text placeholder:text-imi-text/40 transition-colors" />
          <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" placeholder="Password"
            className="w-full bg-imi-bg border border-imi-border focus:border-imi-gold outline-none px-4 py-3 text-imi-text placeholder:text-imi-text/40 transition-colors" />
          {error && <p data-testid="login-error" className="text-red-400 text-sm">{error}</p>}
          <button disabled={loading} type="submit" data-testid="login-submit"
            className="w-full bg-imi-gold text-imi-bg py-3 text-sm uppercase tracking-[0.15em] font-semibold hover:bg-imi-goldlight transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
